import { cn } from '@/lib/utils';
import { FolderOpenDot } from 'lucide-react';
import { ReactNode } from 'react';

interface NotFoundContainerProps {
	title: string;
	message: string | ReactNode;
	className?: string;
}

const NotFoundContainer = ({
	message,
	title,
	className,
}: NotFoundContainerProps) => {
	return (
		<div className={cn('w-fit space-y-4', className)}>
			<div className="mx-auto w-fit rounded-full bg-zinc-200/50 p-6">
				<FolderOpenDot className="size-6 text-zinc-400" />
			</div>
			<div className="text-center">
				<h1 className="text-xl font-light text-zinc-500">{title}</h1>
				<div className="font-light text-zinc-500">{message}</div>
			</div>
		</div>
	);
};

export { NotFoundContainer };
